<script setup lang="ts">
import { ref, watch } from 'vue';
import { NxtButton, NxtInput } from '@future-harry/nxt-styles';
import { MediaItem } from '@/modules/media-library/components/media-library.interface';

const props = defineProps<{ selectedMedia: MediaItem | null }>();
const emit = defineEmits<{
   (e: 'onDelete', id: number): void;
   (e: 'onEdit', payload: { id: number; name: string }): void;
}>();

const name = ref('');
watch(
   () => props.selectedMedia,
   (newVal) => {
      name.value = newVal?.name ?? '';
   },
);
</script>

<template>
   <section class="image-details">
      <template v-if="props.selectedMedia">
         <img v-if="props.selectedMedia.mime_type.includes('image')" :src="props.selectedMedia.url" class="image-details__img" />
         <video
            v-else-if="props.selectedMedia.mime_type.includes('video')"
            :src="props.selectedMedia.url"
            controls
            class="image-details__img"
         ></video>
         <div class="image-details__form">
            <NxtInput :name="'media-library_image_name'" v-model="name" />
         </div>
         <div class="image-details__data">
            <div>{{ props.selectedMedia.file_name }}</div>
            <div>{{ props.selectedMedia.mime_type }}</div>
            <div>{{ props.selectedMedia.human_readable_size }}</div>
            <div>
               <div>{{ $t('media-library.uploaded') }} {{ props.selectedMedia.created_at }}</div>
               <div>{{ $t('media-library.last_updated') }} {{ props.selectedMedia.updated_at }}</div>
            </div>
         </div>
         <div class="image-details__actions">
            <NxtButton button-type="primary" @click="$emit('onEdit', { id: props.selectedMedia.id, name })">{{
               $t('media-library.edit')
            }}</NxtButton>
            <NxtButton button-type="danger" @click="$emit('onDelete', props.selectedMedia.id)">{{ $t('media-library.delete') }}</NxtButton>
         </div>
      </template>
   </section>
</template>

<style lang="scss" scoped>
.image-details {
   display: flex;
   flex-direction: column;
   align-items: flex-start;

   .image-details__img {
      width: 100%;
      border-radius: var(--nxt-radius);
   }

   .image-details__data {
      display: flex;
      flex-direction: column;
      gap: var(--nxt-gutter-small);
   }

   .image-details__actions {
      display: flex;
      gap: var(--nxt-gutter-small);
      margin-top: var(--nxt-gutter-xlarge);
   }

   .image-details__form {
      width: 100%;
      margin: var(--nxt-gutter-large) 0;
   }
}
</style>
